export default __webpack_public_path__ + "static/media/6.903b385e.png";